var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("autocomplete", {
        attrs: {
          label: "digite o email do usuário",
          selected: _vm.user,
          results: _vm.results,
          preloader: _vm.preloader,
          labels: ["first_name", "last_name", "email"],
          separators: [" ", " (", ")"]
        },
        on: { search: _vm.search, select: _vm.selectUser }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("\n    SELECIONE O USUÁRIO\n    "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-674a7862", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-674a7862","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/SelectUser.vue
// module id = null
// module chunks = 